import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import parse from "html-react-parser";
import Spinner from "react-bootstrap/Spinner";
import {
  deleteZoomRecording,
  getSingleMeetingDetails,
  unSetSingleMeetingDetails,
  processCloseMeeting, //added for meeting dropdown
  processCancelMeeting, //added for meeting dropdown
  processdeleteMeeting,
  setIsCheckRequired
} from "../../redux/actions/meetingActions/MeetingAction";
import GuestAttendeesModal from "./GuestAttendeesModal";
import OnlyAttendeeModal from "./OnlyAttendeeModal";
import {
  checkEmptyString,
  combineDateAndTime,
  convertFirstLetterOfFullNameToCapital,
  customName,
  decryptWithAES,
  getColorFromId,
} from "../../helpers/commonHelpers";
import AttendeesDetails from "./AttendeesDetails";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import Alert from "../Common/Alert";
import { logOut } from "../../redux/actions/authActions/authAction";
import {
  Button,
  Popover,
  OverlayTrigger,
  Accordion,
  Tooltip,
} from "react-bootstrap";
import ViewAgendaModal from "../Minutes/ViewAgendaModal";
import ViewZoomRecordings from "./ViewZoomRecordings";
import AddAgendaModal from "../Meeting/AddAgendaModal";
import { addAgendaDetails } from "../../redux/actions/minuteActions/MinuteAction";

//added for meeting dropdown
import Dropdown from "react-bootstrap/Dropdown";
import MeetingDropDown from "../Meeting/MeetingDropDown";

import CancelMeetingModal from "./CancelMeetingModal";
import RescheduleMeetingModal from "./RescheduleMeetingModal";
import ResendMeetingDetailsModal from "./ResendMeetingDetailsModal";
import CommonModal from "../Common/CommonModal";
import EditButton from "../Common/EditButton";
import DeleteMeetingModal from "./DeleteMeetingModal";
import BackButton from "../Common/Backbutton";
import Statistics from "./Statistics";
import AgendaAccordianHeader from "../Common/AgendaAccordianHeader";

const ViewMeetingDetails = React.memo(() => {
  let { id } = useParams();

  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const [isAddAgendaModal, setIsAddAgendaModal] = useState(false);
  const accessToken = localStorage.getItem("accessToken");
  const meetingData = useSelector((state) => state.meeting);
  const employeeData = useSelector((state) => state.user);
  const [attendeesData, setAttendeesData] = useState([]);
  const [recordingData, setRecordingData] = useState([]);
  const [isGuestModalOpen, setIsGuestModalOpen] = useState(false);
  const [isOnlyAttendeeModalOpen, setIsOnlyAttendeeModalOpen] = useState(false);
  const [isViewAgendaModal, setIsViewAgendaModal] = useState(false);
  const [agendaDatas, setAgendaDatas] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteMeetingModalOpen, setIsDeleteMeetingModalOpen] =
    useState(false);
  const [isViewZoomRecordingModal, setIsViewZoomRecordingModal] =
    useState(false);
  const [recordingId, setRecordingId] = useState(null);

  // added for meeting dropdown
  const [meetingId, setMeetingId] = useState(null);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [singleMeetingDetails, setSingleMeetingDetails] = useState(null);
  const [isResendMeetingDetailsModalOpen, setIsResendMeetingDetailsModalOpen] =
    useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  useEffect(() => {
    return ()=>{
    //  alert(2222)
      dispatch(setIsCheckRequired(false));
    }
    
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  

  useEffect(() => {
    document.title = "Meeting Details: MinutesVault";

    const fetchData = async () => {
      if (accessToken) {
        const result = await dispatch(getSingleMeetingDetails(id, accessToken));
        if (result?.isReload) {
          dispatch(setIsCheckRequired(false))
        }
        else{
           dispatch(setIsCheckRequired(true))
        }
      }
    };

    fetchData();

    return () => {
      dispatch(unSetSingleMeetingDetails());
    };
  }, []);

  const onAddAgenda = (data) => {
    dispatch(
      addAgendaDetails(
        {
          agendaData: [
            {
              topic: data.topic,
              timeLine: data.timeLine,
              title: data.title,
              organizationId: meetingData?.meetingDetails?.organizationId,
              meetingId: meetingData?.meetingDetails?._id,
            },
          ],
        },
        meetingData?.meetingDetails?._id,
        accessToken
      )
    );
  };

  useEffect(() => {
     //  alert(0)
    if (
      employeeData?.userData?.organizationId &&
      meetingData?.singleMeetingDetails?.organizationId
    ) {
     //  alert(1)
      if (
        employeeData?.userData?.organizationId !==
        meetingData?.singleMeetingDetails?.organizationId && meetingData?.isCheckRequired
      ) {
         navigate("/pagenotfound");
      }
    }
  }, [
    employeeData?.userData?.organizationId,
    meetingData?.singleMeetingDetails?.organizationId,
    meetingData?.isCheckRequired
  ]);

  useEffect(() => {
    if (meetingData?.singleMeetingDetails?.recordings?.recordingFile) {
      setRecordingData(
        meetingData?.singleMeetingDetails?.recordings?.recordingFile
      );
    } else {
      setRecordingData([]);
    }
  }, [meetingData?.singleMeetingDetails?.recordings?.recordingFile]);

  useEffect(() => {
    if (meetingData?.isSuccess && recordingId !== null) {
      var newRecordingData = recordingData?.filter(
        (recording) => recording?.id != recordingId
      );

      setRecordingData(newRecordingData);

      if (newRecordingData?.length === 0) {
        setIsViewZoomRecordingModal(false);
      }
    }
  }, [meetingData?.isSuccess]);
  const setGuestModalStatus = (value, attendeesData) => {
    if (attendeesData.length !== 0) {
      setIsGuestModalOpen(value);
      setAttendeesData([...attendeesData]);
    }
  };
  const setOnlyAttendeeModalStatus = (value, attendeesData) => {
    if (attendeesData.length !== 0) {
      setIsOnlyAttendeeModalOpen(value);
      setAttendeesData([...attendeesData]);
    }
  };

  const setViewZoomRecordingModalStatus = (value) => {
    setIsViewZoomRecordingModal(value);
  };
  const isMeetingOrganiser =
    employeeData?.userData?._id?.toString() ===
    meetingData?.singleMeetingDetails?.createdById.toString()
      ? true
      : false;

  const handleDeleteSubmit = async () => {
    const payload = {
      meetingId: meetingData?.singleMeetingDetails?._id,
      recordingId,
      organizationId: meetingData?.singleMeetingDetails?.organizationId,
    };
    setIsLoading(true);
    const result = await dispatch(deleteZoomRecording(payload, accessToken));
    setIsLoading(false);
    if (result?.status) {
      setIsDeleteModalOpen(false);
    }
  };
  const handleOpenDeleteModal = (singleRecordingId, status) => {
    setIsDeleteModalOpen(status);
    setRecordingId(singleRecordingId);
  };
  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee.name} / {attendee?.email}
      </Tooltip>
    );
  };
  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };

  const handleAddAgendaModal = (status) => {
    setIsAddAgendaModal(status);
  };

  //modals for meeting dropdown
  const handleCancelMeeting = async (remarks) => {
    const result = await dispatch(
      processCancelMeeting(meetingId, { remarks }, accessToken)
    );
    if (result?.status) {
      setMeetingId(null);
      setIsCancelModalOpen(false);
      if (accessToken) {
        dispatch(getSingleMeetingDetails(id, accessToken));
      }
    }
  };

  const handleCloseMeeting = () => {
    dispatch(
      processCloseMeeting(meetingId, { meetingStatus: "closed" }, accessToken)
    );
    setMeetingId(null);
    setIsCloseModalOpen(false);
  };

  const handleCancelModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsCancelModalOpen(true);
  };

  const handleCloseModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsCloseModalOpen(true);
  };

  const handleRescheduleModal = (singleMeetingDetails) => {
    setSingleMeetingDetails(singleMeetingDetails);
    setIsRescheduleModalOpen(true);
  };
  const handleResendMeetingDetailsModal = (singleMeetingDetails) => {
    setSingleMeetingDetails(singleMeetingDetails);
    setIsResendMeetingDetailsModalOpen(true);
  };

  ////////////// delete meeting //////////////

  const handleDeleteModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsDeleteMeetingModalOpen(true);
  };

  const handleDeleteMeeting = () => {
    dispatch(processdeleteMeeting(meetingId, accessToken));
    setMeetingId(null);
    setTimeout(() => {
      navigate("/meeting-list");
    }, 500);
  };

  ///////////////////////////

  const meeting = meetingData?.singleMeetingDetails;

  let meetingDetailss = meeting;

  // Check if agendaDetails is defined and has items
  if (meetingData?.agendaDetails?.length !== 0) {
    // Find the action details where minutesDetail is not empty
    const actionDetails = meetingData.agendaDetails.find(
      (agenda) => agenda?.minutesDetail?.length !== 0
    );

    // Initialize meetingDetailss if it's not defined
    if (!meetingDetailss) {
      meetingDetailss = {};
    }

    // Check if actionDetails is undefined (find returns undefined if no match is found)
    if (actionDetails === undefined) {
      meetingDetailss["actionDetail"] = [];
    } else {
      meetingDetailss["actionDetail"] = [actionDetails];
    }
  }

  let organizationData = useSelector((state) => state.organization);
  let isWriteMinuteAllowedForClosedMinutes = true;
  let isWriteMinuteAllowed = true;

  if (meeting) {
    const meetingDateTime = combineDateAndTime(
      new Date(meeting?.actualDate),
      meeting?.actualFromTime
    ).getTime();

    const currentDateTime = new Date().getTime();

    if (meeting?.meetingCloseDetails?.closedAt) {
      const utcDate = new Date(meeting?.meetingCloseDetails?.closedAt);
      utcDate.setMinutes(utcDate.getMinutes() - (5 * 60 + 30));
      const meetingCloseTime = utcDate.getTime();
      const closedTime = meeting?.meetingCloseDetails?.closedAt
        ? meetingCloseTime
        : 0;

      const targetHoursInMilliSecond = organizationData?.organizationData
        ?.configData?.writeMinuteMaxTimeInHour
        ? parseInt(
            organizationData?.organizationData?.configData
              ?.writeMinuteMaxTimeInHour
          ) * 3600000
        : 0;

      if (targetHoursInMilliSecond === 0) {
        isWriteMinuteAllowedForClosedMinutes = false;
      } else {
        isWriteMinuteAllowedForClosedMinutes =
          currentDateTime - closedTime > targetHoursInMilliSecond
            ? false
            : true;
      }
    }

    isWriteMinuteAllowed = meetingDateTime <= currentDateTime ? true : false;
  }

  const camefromPreviousPage = location.state?.camefromPreviousPage || false;

  const isMeetingHost =
    meetingData?.singleMeetingDetails?.createdById ===
    employeeData?.userData?._id;

  const showActionOptions = employeeData?.userData?.isAdmin
    ? true
    : employeeData?.userData?.isAdmin === false && isMeetingHost
      ? true
      : meeting?.canWriteMOM === true
        ? true
        : false;
  return (
    <>
      {/* added for dropdown */}
      {isCancelModalOpen && (
        <CancelMeetingModal
          setIsModalOpen={setIsCancelModalOpen}
          isModalOpen={isCancelModalOpen}
          handleSubmit={handleCancelMeeting}
        />
      )}
      {isCloseModalOpen && (
        <CommonModal
          message={"Do you want to close the meeting ?"}
          title={"Close Meeting"}
          setIsModalOpen={setIsCloseModalOpen}
          isModalOpen={isCloseModalOpen}
          handleSubmit={handleCloseMeeting}
          buttonName={"Close"}
        />
      )}
      {isRescheduleModalOpen && (
        <RescheduleMeetingModal
          setIsRescheduleModalOpen={setIsRescheduleModalOpen}
          isRescheduleModalOpen={isRescheduleModalOpen}
          meetingData={singleMeetingDetails}
          isFetchedMeetingList={false}
        />
      )}
      {isResendMeetingDetailsModalOpen && (
        <ResendMeetingDetailsModal
          isResendMeetingDetailsModalOpen={isResendMeetingDetailsModalOpen}
          setIsResendMeetingDetailsModalOpen={
            setIsResendMeetingDetailsModalOpen
          }
          meetingDetail={singleMeetingDetails}
        />
      )}
      {isDeleteModalOpen ? (
        <div className="alert-wrapper">
          <div className="alert-container">
            <div className="alert-icon alert-warning alert-icon-show">
              <div className="alert-icon-content">!</div>
            </div>
            <h2 className="alert-title">Are you sure? </h2>
            <div className="alert-html-container">
              You want to delete this recording?
              <br />
              <span>You will not be able to recover this file later!</span>
            </div>
            <div className="alert-actions">
              {!isLoading ? (
                <button
                  className="create-meeting-button Mom-btn alert-confirm"
                  type="button"
                  onClick={() => handleDeleteSubmit()}
                >
                  <p>Yes, delete it!</p>
                </button>
              ) : (
                <Button className="add-btn Mom-btn" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  {"  "}
                  Processing...
                </Button>
              )}

              <button
                type="button"
                className="add-minutes Mom-btn btn alert-cancel"
                onClick={() => setIsDeleteModalOpen(false)}
              >
                <p>Cancel</p>
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {(meetingData?.singleMeetingDetails?.meetingStatus?.status ===
        "scheduled" ||
        meetingData?.singleMeetingDetails?.meetingStatus?.status ===
          "rescheduled" ||
        meetingData?.singleMeetingDetails?.meetingStatus?.status === "draft") &&
      (isMeetingOrganiser === true ||
        employeeData?.userData?.isAdmin === true) &&
      !(meetingData?.singleMeetingDetails?.actionDetail?.length > 0) &&
      meetingData?.singleMeetingDetails?.isActive !== false ? (
        <EditButton meetingData={meetingData} />
      ) : null}
      {meetingData.singleMeetingDetails !== null ? (
        <div className="main-content">
          <div className="page-heading d-flex justify-content-between align-items-center">
            <div className="meeting-header-text  line-height-h4">
              <h4>Meeting Details</h4>
            </div>

            <div className="agenda-btn-icon ">
              {employeeData?.userData?.isEmployee === true ? (
                <Link
                  className="btn add-btn Mom-btn d-flex align-items-center justify-content-center btn btn-primary filter-height"
                  id="open-form-btn"
                  to={
                    meetingData?.singleMeetingDetails?.parentMeetingId
                      ? `/create-followon/${meetingData?.singleMeetingDetails?.parentMeetingId}`
                      : `/create-followon/${meetingData?.singleMeetingDetails?._id}`
                  }
                  state={{
                    meetingId: id,
                    isMeetingDataUpdate: true,
                    step: meetingData,
                    camefromPreviousPage: true,
                    scrollToId: `meeting-${meetingData?.singleMeetingDetails?._id}`,
                  }}
                  style={{
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  <p>Timeline</p>
                </Link>
              ) : null}

              <div className="d-inline-block d-flex menu-dropdown custom-dropdown gap-8px">
                <div className="dropdown">
                  <div className="meeting-header-text line-height-h4 timeline-div">
                    <h4></h4>
                  </div>
                  {meetingData?.singleMeetingDetails?.isActive !== false &&
                  showActionOptions ? (
                    <div className="d-inline-block menu-dropdown custom-dropdown">
                      <Dropdown>
                        <MeetingDropDown
                          meetingDetails={meeting}
                          meetingId={meeting._id}
                          status={meeting.meetingStatus?.status}
                          handleCancelModal={() =>
                            handleCancelModal(meeting._id)
                          }
                          handleResendMeetingDetailsModal={() =>
                            handleResendMeetingDetailsModal(meeting)
                          }
                          handleRescheduleModal={() =>
                            handleRescheduleModal(meeting)
                          }
                          handleCloseModal={() => handleCloseModal(meeting._id)}
                          handleDeleteModal={(meetingId) => {
                            handleDeleteModal(meeting._id);
                          }}
                        />
                      </Dropdown>
                    </div>
                  ) : null}
                </div>

                <BackButton show={camefromPreviousPage} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <form className="details-form details-form-right">
                {meetingData?.singleMeetingDetails?.parentMeetingDetails
                  ?.length !== 0 ? (
                  <>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                          <label className="mb-1">Parent Meeting ID</label>
                        </div>
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                          <Link
                            className="meeting-title-a"
                            to={`/view-meeting-details/${meetingData?.singleMeetingDetails?.parentMeetingDetails[0]?._id}`}
                            target="_blank"
                          >
                            <p className="meeting-day meeting-details-p">
                              {
                                meetingData?.singleMeetingDetails
                                  ?.parentMeetingDetails[0].meetingId
                              }
                            </p>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                          <label className="mb-1">Parent Meeting Title</label>
                        </div>
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                          <p>
                            {
                              meetingData?.singleMeetingDetails
                                ?.parentMeetingDetails[0].title
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                          <label className="mb-1">
                            Follow-On Serial Number
                          </label>
                        </div>
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                          <p>
                            {meetingData.singleMeetingDetails?.followOnSerialNo}
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}

                <div className="form-group ">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">
                        {meetingData.singleMeetingDetails?.parentMeetingDetails
                          ?.length
                          ? "Follow-On Meeting Id"
                          : "Meeting Id"}
                      </label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      <p className="meeting-day meeting-details-b">
                        {meetingData.singleMeetingDetails?.meetingId}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">
                        {meetingData.singleMeetingDetails?.parentMeetingDetails
                          ?.length
                          ? "Follow-On Meeting Title"
                          : "Title"}
                      </label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      <p>{meetingData.singleMeetingDetails?.title}</p>
                    </div>
                  </div>
                </div>

                <div className="form-group ">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">Meeting Mode</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      <p>
                        {convertFirstLetterOfFullNameToCapital(
                          meetingData.singleMeetingDetails?.mode
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">Location</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      <p>
                        {meetingData.singleMeetingDetails?.locationDetails
                          .isMeetingRoom === true
                          ? meetingData.singleMeetingDetails?.roomDetail[0]
                              ?.title +
                            ", " +
                            meetingData.singleMeetingDetails?.roomDetail[0]
                              .location +
                            ", " +
                            meetingData?.singleMeetingDetails?.unitDetail?.name
                          : meetingData.singleMeetingDetails?.locationDetails
                              .location}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">Meeting Link </label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      {meetingData?.singleMeetingDetails?.link &&
                      meetingData?.singleMeetingDetails?.hostDetails
                        ?.hostType === "MANUAL" ? (
                        <Link
                          target={"_blank"}
                          to={meetingData?.singleMeetingDetails?.link}
                        >
                          Click to Join Meeting
                        </Link>
                      ) : meetingData?.singleMeetingDetails?.link ? (
                        <>
                          <Link
                            target={"_blank"}
                            to={
                              meetingData?.singleMeetingDetails?.createdById?.toString() ===
                              employeeData?.userData?._id?.toString()
                                ? meetingData?.singleMeetingDetails?.hostDetails
                                    ?.hostLink
                                : meetingData?.singleMeetingDetails?.link
                            }
                          >
                            Click to Join Meeting
                          </Link>

                          {(meetingData.singleMeetingDetails?.meetingStatus
                            ?.status === "scheduled" ||
                            meetingData.singleMeetingDetails?.meetingStatus
                              ?.status === "rescheduled") === true &&
                          meetingData?.singleMeetingDetails?.hostDetails
                            ?.hostType === "ZOOM" ? (
                            <p>
                              {" "}
                              ( Host Key :{" "}
                              {decryptWithAES(
                                meetingData?.singleMeetingDetails
                                  ?.meetingHostDetails?.zoomCredentials?.hostKey
                              )}{" "}
                              )
                            </p>
                          ) : null}
                        </>
                      ) : meetingData?.singleMeetingDetails?.hostDetails
                          ?.hostType === "ZOOM" &&
                        !meetingData?.singleMeetingDetails?.link ? (
                        <>
                          {meetingData.singleMeetingDetails?.meetingStatus
                            ?.status === "draft" ? (
                            <p>
                              Zoom link will be added once schedule the meeting
                            </p>
                          ) : (
                            <p>
                              Zoom link will be added once notification sent
                            </p>
                          )}
                        </>
                      ) : meetingData?.singleMeetingDetails?.hostDetails
                          ?.hostType === "GMEET" &&
                        !meetingData?.singleMeetingDetails?.link ? (
                        <>
                          {meetingData.singleMeetingDetails?.meetingStatus
                            ?.status === "draft" ? (
                            <p>
                              Google Meet link will be added once schedule the
                              meeting
                            </p>
                          ) : (
                            <p>
                              Google Meet link will be added once notification
                              sent
                            </p>
                          )}
                        </>
                      ) : meetingData?.singleMeetingDetails?.hostDetails
                          ?.hostType === "MSTEAMS" &&
                        !meetingData?.singleMeetingDetails?.link ? (
                        <>
                          {meetingData.singleMeetingDetails?.meetingStatus
                            ?.status === "draft" ? (
                            <p>
                              Microsoft Teams link will be added once schedule
                              the meeting
                            </p>
                          ) : (
                            <p>
                              Microsoft Teams link will be added once
                              notification sent
                            </p>
                          )}
                        </>
                      ) : (
                        <p> NA</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">Recordings </label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      {meetingData?.singleMeetingDetails?.hostDetails
                        ?.hostType === "ZOOM" &&
                      meetingData?.singleMeetingDetails?.recordings &&
                      recordingData?.length !== 0 ? (
                        <>
                          <button
                            className="p-0 resp-recording-view"
                            type="button"
                            onClick={() =>
                              setViewZoomRecordingModalStatus(true)
                            }
                          >
                            <span className="recording-btn">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="#5f07b0"
                                className="bi bi-eye-fill me-2"
                                viewBox="0 0 16 16"
                              >
                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                              </svg>
                              View
                            </span>
                          </button>
                        </>
                      ) : (
                        <p>NA</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">Date & Time</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                      <p>
                        {meetingData.singleMeetingDetails?.date},{" "}
                        {meetingData.singleMeetingDetails?.fromTime} to{" "}
                        {meetingData.singleMeetingDetails?.toTime}{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <label className="mb-1">Status</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 d-flex">
                      <span
                        className={`badge bg-opacity-10 ${
                          meetingData.singleMeetingDetails?.meetingStatus
                            ?.status === "scheduled"
                            ? "scheduled-color"
                            : meetingData.singleMeetingDetails?.meetingStatus
                                  ?.status === "rescheduled"
                              ? "rescheduled-color"
                              : meetingData.singleMeetingDetails?.meetingStatus
                                    ?.status === "closed"
                                ? "closed-color"
                                : meetingData.singleMeetingDetails
                                      ?.meetingStatus?.status === "draft"
                                  ? "draft-color"
                                  : "canceled-color"
                        }`}
                      >
                        {meetingData.singleMeetingDetails?.meetingStatus?.status
                          .charAt(0)
                          .toUpperCase() +
                          meetingData.singleMeetingDetails?.meetingStatus?.status.slice(
                            1
                          )}
                      </span>
                      <div className="d-flex align-items-center justify-content-between">
                        {meetingData.singleMeetingDetails?.isActive ===
                        false ? (
                          <span className="badge canceled-color bg-opacity-10 deleted-icon mx-2">
                            Deleted
                          </span>
                        ) : (
                          <p></p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {meetingData.singleMeetingDetails?.meetingStatus?.status ===
                  "rescheduled" ||
                meetingData.singleMeetingDetails?.meetingStatus?.status ===
                  "cancelled" ? (
                  <div className="form-group">
                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <label className="mb-1">Reason</label>
                      </div>
                      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                        <p>
                          {
                            meetingData.singleMeetingDetails?.meetingStatus
                              ?.remarks
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                ) : null}

                {meetingData?.singleMeetingDetails?.isRescheduled &&
                meetingData?.singleMeetingDetails?.rescheduledMeetingDetails
                  ?.length !== 0 ? (
                  <div className="form-group">
                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <label className="mb-1">Rescheduled Meeting</label>
                      </div>
                      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                        {/* <ol> */}
                        {meetingData.singleMeetingDetails?.rescheduledMeetingDetails?.map(
                          (meetings, index) => {
                            return (
                              <Link
                                target={"_blank"}
                                to={`/view-meeting-details/${meetings?._id}`}
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                              >
                                {/* <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-top">Go to Meeting Details</Tooltip>
                    }
                  > */}
                                {/* <li>
                                    {meetings?.title} ({meetings?.meetingId})
                                  </li> */}
                                <p> {meetings?.title} </p>
                                <p
                                  className="meeting-details-p">
                                  {" "}
                                  ({meetings?.meetingId}){" "}
                                </p>
                              </Link>
                            );
                          }
                        )}
                        {/* </ol> */}
                      </div>
                    </div>
                  </div>
                ) : null}

                {meetingData?.singleMeetingDetails
                  ?.rescheduledForMeetingDetails &&
                meetingData?.singleMeetingDetails?.rescheduledForMeetingDetails
                  ?.length !== 0 ? (
                  <div className="form-group">
                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                        <label className="mb-1">Rescheduled From</label>
                      </div>
                      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                        <Link
                          target={"_blank"}
                          to={`/view-meeting-details/${meetingData?.singleMeetingDetails?.rescheduledForMeetingDetails[0]?._id}`}
                          style={{
                            textDecoration: "none",
                            color: "black",
                          }}
                        >
                          <p>
                            {
                              meetingData?.singleMeetingDetails
                                ?.rescheduledForMeetingDetails[0]?.title
                            }{" "}
                          </p>
                          <p className="meeting-day meeting-details-p">
                            (
                            {
                              meetingData?.singleMeetingDetails
                                ?.rescheduledForMeetingDetails[0]?.meetingId
                            }
                            )
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                ) : null}

                {meetingData.singleMeetingDetails?.attendees?.length > 0 && (
                  <>
                    {meetingData.singleMeetingDetails.attendees.some(
                      (att) => att.isEmployee
                    ) && (
                      <div className="form-group">
                        <div className="row align-items-center">
                          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                            <label>Attendee(s)</label>
                          </div>
                          <div
                            className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                            onClick={() =>
                              setOnlyAttendeeModalStatus(
                                true,
                                meetingData.singleMeetingDetails.attendees
                              )
                            }
                          >
                            <div className="attendees">
                              {meetingData.singleMeetingDetails.attendees
                                .filter((att) => att.isEmployee)
                                .slice(0, 5)
                                .map((guest) => (
                                  <OverlayTrigger
                                    key={guest._id}
                                    placement="top"
                                    overlay={tooltip(guest)}
                                    trigger={["hover", "focus"]}
                                  >
                                    <div
                                      className={`attendee-list attendee-list-circle${
                                        meetingData.singleMeetingDetails.createdById?.toString() ===
                                        guest._id?.toString()
                                          ? " attendees-border"
                                          : ""
                                      }`}
                                      style={{
                                        backgroundColor: guest.profilePicture
                                          ? "transparent"
                                          : getColorFromId(guest._id),
                                      }}
                                    >
                                      {guest.profilePicture ? (
                                        <img
                                          src={`${process.env.REACT_APP_API_URL}${guest.profilePicture}`}
                                          alt={guest.name}
                                          className="attendee-profile-picture icon-image profile-picture attendee-list-circle-img"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.style.display = "none";
                                            e.target.parentElement.style.backgroundColor =
                                              getColorFromId(guest._id);
                                            e.target.parentElement.innerText =
                                              customName(guest.name);
                                          }}
                                        />
                                      ) : (
                                        <span className="attendee-name">
                                          {customName(guest.name)}
                                        </span>
                                      )}
                                    </div>
                                  </OverlayTrigger>
                                ))}

                              {/* +More for Attendees */}
                              {meetingData.singleMeetingDetails.attendees.filter(
                                (guest) => guest.isEmployee
                              ).length > 5 && (
                                <p className="m-0">
                                  +
                                  {meetingData.singleMeetingDetails.attendees.filter(
                                    (guest) => guest.isEmployee
                                  ).length - 5}{" "}
                                  More
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {meetingData.singleMeetingDetails.attendees.some(
                      (att) => att.isEmployee === false
                    ) && (
                      <div className="form-group">
                        <div className="row align-items-center">
                          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                            <label>Guest(s)</label>
                          </div>
                          <div
                            className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
                            onClick={() =>
                              setGuestModalStatus(
                                true,
                                meetingData.singleMeetingDetails.attendees
                              )
                            }
                          >
                            <div className="attendees" title="Guest">
                              {meetingData.singleMeetingDetails.attendees
                                .filter((att) => att.isEmployee === false)
                                .slice(0, 5)
                                .map((guest) => (
                                  <OverlayTrigger
                                    key={guest._id}
                                    placement="top"
                                    overlay={tooltip(guest)}
                                    trigger={["hover", "focus"]}
                                  >
                                    <div
                                      className="attendee-list attendee-list-circle"
                                      style={{
                                        backgroundColor: guest.profilePicture
                                          ? "transparent"
                                          : getColorFromId(guest._id),
                                      }}
                                    >
                                      {guest.profilePicture ? (
                                        <img
                                          src={`${process.env.REACT_APP_API_URL}${guest.profilePicture}`}
                                          alt={guest.name}
                                          className="attendee-profile-picture icon-image profile-picture attendee-list-circle-img"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.style.display = "none";
                                            e.target.parentElement.style.backgroundColor =
                                              getColorFromId(guest._id);
                                            e.target.parentElement.innerText =
                                              customName(guest.name);
                                          }}
                                        />
                                      ) : (
                                        <span className="attendee-name">
                                          {customName(guest.name)}
                                        </span>
                                      )}
                                    </div>
                                  </OverlayTrigger>
                                ))}

                              {/* +More for Guests */}
                              {meetingData.singleMeetingDetails.attendees.filter(
                                (guest) => guest.isEmployee === false
                              ).length > 5 && (
                                <p className="m-0">
                                  +
                                  {meetingData.singleMeetingDetails.attendees.filter(
                                    (guest) => guest.isEmployee === false
                                  ).length - 5}{" "}
                                  More
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {meetingData.singleMeetingDetails?.agendasDetail.length !==
                0 ? (
                  <>
                    <div className="minutes-border"></div>
                    <div className="form-group mt-4 agenda">
                      <div className="agendas-header d-flex align-items-center justify-content-between">
                        <div>
                          <label className="mt-3 mb-3">
                            <h4 className="mb-0">Agenda(s)</h4>
                          </label>
                        </div>

                        {(isWriteMinuteAllowed &&
                          ["scheduled", "rescheduled"].includes(
                            meeting?.meetingStatus?.status
                          ) &&
                          meetingData?.singleMeetingDetails?.isActive !==
                            false &&
                          (isMeetingOrganiser ||
                            employeeData?.userData?.isAdmin ||
                            meeting?.canWriteMOM ||
                            meeting?.canWriteMOM)) ||
                        (meeting?.meetingStatus?.status === "closed" &&
                          (isMeetingOrganiser ||
                            employeeData?.userData?.isAdmin ||
                            meeting?.canWriteMOM ||
                            meeting?.canWriteMOM) &&
                          isWriteMinuteAllowedForClosedMinutes) ? (
                          <div className="right-div d-flex align-items-center">
                            <div
                              id="open-form-btn"
                              onClick={() => {
                                handleAddAgendaModal(true);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                fill="#0564f3"
                                className="bi bi-plus-circle pointer"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                              </svg>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      {meetingData.singleMeetingDetails?.agendasDetail
                        .length !== 0 &&
                        meetingData.singleMeetingDetails?.agendasDetail.map(
                          (agenda, index) => {
                            return (
                              <div className="mt-2 agenda-box-border">
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item
                                    eventKey={index.toString()}
                                    key={index}
                                    className="agenda-accordion view-meeting-accordion"
                                  >
                                    <AgendaAccordianHeader
                                      agenda={agenda}
                                      index={index}
                                      minutesCount={agenda?.activeMinutesCount}
                                    />

                                    <Accordion.Body>
                                      <div className="">
                                        <div className="form-group">
                                          <div className="row">
                                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                              <label className="mt-1 mb-1">
                                                Agenda Title
                                              </label>
                                            </div>
                                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                              <p> {agenda.title}</p>
                                            </div>
                                          </div>
                                        </div>
                                        {checkEmptyString(agenda?.topic) ===
                                          null ||
                                        checkEmptyString(agenda?.topic) ===
                                          " " ||
                                        checkEmptyString(agenda?.topic) ===
                                          undefined ||
                                        agenda?.topic === null ? null : (
                                          <div className="form-group">
                                            <div className="row">
                                              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                                <label className="mt-2 topic">
                                                  Topic to Discuss
                                                </label>
                                              </div>
                                              <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                                <div className="mb-2 text-editor">
                                                  {agenda?.topic
                                                    ? parse(
                                                        decryptWithAES(
                                                          agenda.topic
                                                        )
                                                      )
                                                    : null}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        <div className=" form-group">
                                          <div className="row">
                                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                              <label className="mt-1 mb-1">
                                                Timeline
                                              </label>
                                            </div>
                                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                              <p> {agenda.timeLine} Mins</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </div>
                            );
                          }
                        )}
                    </div>
                  </>
                ) : (
                  <>
                    <Alert
                      status={"info"}
                      message={"No Agenda Added"}
                      timeoutSeconds={0}
                    />
                    <div className="mt-3 agenda-box-border no-data-img mt-3">
                      <NoDataFound dataType={"agenda"} />
                    </div>
                  </>
                )}
              </form>
            </div>
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <form className="details-form details-form-right resp-mt-30">
                {meetingData.singleMeetingDetails?.attendees.length > 0 ? (
                  <div className="form-group mb-2">
                    <AttendeesDetails
                      attendeesData={meetingData.singleMeetingDetails}
                    />
                  </div>
                ) : (
                  <>
                    <Alert
                      status={"info"}
                      message={"No Attendee Added"}
                      timeoutSeconds={0}
                    />
                    <div className="mt-3 agenda-box-border no-data-img mt-3">
                      <NoDataFound dataType={"attendee"} />
                    </div>
                  </>
                )}
              </form>

              {/* STATISTICS CODE STAT */}
              <form className="mt-4 details-form details-form-right">
                <div className="form-group mb-2">
                  <Statistics
                    meetingId={meetingData.singleMeetingDetails?._id}
                  />
                </div>
              </form>
              {/* STATISTICS CODE END */}
            </div>
          </div>
        </div>
      ) : meetingData.singleMeetingDetails === null &&
        !meetingData.loading &&
        !meetingData.isSuccess ? (
        <div className="main-content">
          <div className="row">
            <div className="meeting-header-text  line-height-h4">
              <h4>Meeting Details</h4>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <form className="mt-2 details-form details-form-right">
                <div className="row">
                  <Alert
                    status={"info"}
                    message={"No data available."}
                    timeoutSeconds={0}
                  />
                  <NoDataFound dataType={"meeting"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="main-content">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
              <div className="meeting-header-text line-height-h4">
                <h4>Meeting Details</h4>
              </div>

              <form className="mt-2 details-form details-form-right">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Loader />
                </div>
              </form>
            </div>
          </div>
        </div>
      )}{" "}
      {isGuestModalOpen && (
        <GuestAttendeesModal
          IsGuestModalOpen={isGuestModalOpen}
          attendees={attendeesData}
          setIsGuestModalOpen={setIsGuestModalOpen}
        />
      )}
      {isOnlyAttendeeModalOpen && (
        <OnlyAttendeeModal
          IsOnlyAttendeeModalOpen={isOnlyAttendeeModalOpen}
          attendees={attendeesData}
          setIsOnlyAttendeeModalOpen={setIsOnlyAttendeeModalOpen}
          meetingData={meetingData}
        />
      )}
      {isViewAgendaModal && (
        <ViewAgendaModal
          agendaData={agendaDatas}
          IsViewAgendaModal={isViewAgendaModal}
          setIsViewAgendaModal={setIsViewAgendaModal}
        />
      )}
      {isViewZoomRecordingModal && (
        <ViewZoomRecordings
          singleMeetingDetails={meetingData?.singleMeetingDetails}
          IsViewZoomRecordingModal={isViewZoomRecordingModal}
          setIsViewZoomRecordingModal={setIsViewZoomRecordingModal}
          handleOpenDeleteModal={handleOpenDeleteModal}
          recordingData={recordingData}
        />
      )}
      {isAddAgendaModal && (
        <AddAgendaModal
          IsAddAgendaModal={isAddAgendaModal}
          setIsAddAgendaModal={setIsAddAgendaModal}
          addAgenda={onAddAgenda}
          totalAgenda={meetingData.singleMeetingDetails?.agendasDetail?.length}
          fromViewMeeting={true}
          agendaDetails={meetingData.singleMeetingDetails?.agendasDetail}
        />
      )}
      {isDeleteMeetingModalOpen && (
        <DeleteMeetingModal
          setIsModalOpen={setIsDeleteMeetingModalOpen}
          isModalOpen={isDeleteMeetingModalOpen}
          handleSubmit={handleDeleteMeeting}
        />
      )}
    </>
  );
});

export default ViewMeetingDetails;
